// VariableContext.js
import React from 'react';

const VariableContext = React.createContext();

export default VariableContext;
